<template>
  <div style="">
    <div v-for="(row, idx) in summary" :key="idx">
      <div v-if="row.Ordr % 2 == 1" class="dash-header">
        <div style="font-weight:bold; width:50%; position:relative; top:3px;">
          {{ row.NamaPotensi }}
        </div>
        <v-chip small v-if="totalPotensi && row.Ordr == 1">
          {{ totalAktif }} / {{ totalPotensi }}
        </v-chip>
        <v-spacer />
        <div
          style="text-align:right; font-size:small; margin-right:8px; position:relative; top:1px;"
          v-if="totalPotensi && row.Ordr == 1"
        >
          {{ hargaAktif | format }} / {{ hargaPotensi | format }}
        </div>
        <div
          style="text-align:right; font-size:small; background:red; 
          padding:7px 6px; position:absolute; top:0px; right:0px; 
          color:white; min-width:45px;"
          v-if="totalPotensi && row.Ordr == 1"
        >
          {{ parseInt((totalAktif / (totalPotensi || 1)) * 100) }}%
        </div>
      </div>
      <div
        v-else
        style="display:flex;padding:5px; border-bottom: 1px solid silver; position:relative; padding-right: 40px"
      >
        <div
          style="width:50%; font-size:12px; position:relative; top:4px; font-weight:bold; color:#555"
        >
          {{ row.NamaPotensi | fixcase }}
        </div>
        <v-chip small> {{ row.JmlAktif }} / {{ row.JmlPotensi }} </v-chip>
        <v-spacer />
        <div
          style="text-align:right; font-size:small; margin-right:8px; margin-top:2px; position:relative; top:1px;"
        >
          {{ row.HargaAktif | format }} / {{ row.HargaPotensi | format }}
        </div>
        <div
          :style="
            row.JmlAktif / (row.JmlPotensi || 1) >= 8 / 12
              ? 'background:green'
              : 'background:red'
          "
          style="text-align:right; font-size:small;
          padding:7px 6px; position:absolute; top:0px; right:0px; 
          color:white; min-width:45px;"
        >
          {{ parseInt((row.JmlAktif / (row.JmlPotensi || 1)) * 100) }}%
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data: () => ({
    summary: [],
    totalAktif: 0,
    totalPotensi: 0,
    hargaAktif: 0,
    hargaPotensi: 0,
  }),
  props: {
    params: Object,
  },
  watch: {
    'params.AssetId'(id) {
      this.PopulateSummary(this.params.BalaiId, id)
    },
    'params.BalaiId'(id) {
      this.PopulateSummary(id, this.params.AssetId)
    },
  },
  mounted() {
    this.$api.Authorize()
    this.PopulateSummary(this.params.BalaiId, this.params.AssetId)
  },
  methods: {
    async PopulateSummary(BalaiId, AssetId) {
      let d = await this.$api.call('AST.SelSummary', {
        BalaiId,
        AssetId,
      })
      for (let r of d.data) {
        if (r.Ordr == 2) {
          this.totalAktif += r.JmlAktif
          this.totalPotensi += r.JmlPotensi
          this.hargaAktif += r.HargaAktif
          this.hargaPotensi += r.HargaPotensi
        }
      }
      this.summary = d.data
    },
  },
}
</script>
